import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import SignIn from '../views/SignIn.vue'
import Profile from '../views/user/Profile.vue'
import FAQ from '../views/FAQ'
import About from '../views/About'
import ZeroOneSpace from '../views/ZeroOneSpace'
import Event from "@/views/events/Event";
import SelectedCompetitions from "@/views/competitions/SelectedCompetitions"
import TrainingSupport from "../views/TrainingAndSupport"
import EventsDetails from "@/views/events/EventsDetails";
import LeaderBoard from "@/views/events/LeaderBoard";
import myTeamInfo from "@/views/user/myTeamInfo"
import Notification from "@/components/user/Notification";


import store from "../store/index"

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/competitions',
        name: 'Competitions',
        component: () => import('../views/competitions/Competitions.vue'),
    },
    {
        path: '/competitions/:id',
        name: 'SelectedCompetitions',
        component: SelectedCompetitions,
    },
    {
        path: '/event',
        name: 'Event',
        component: Event,
    },
    {
        path: '/event/:id',
        name: 'Event-Details',
        component: EventsDetails,
    },
    {
        path: '/event/details/all-leaderBoard/:id',
        name: 'all-leaderBoard',
        component: LeaderBoard,
    },

    {
        path: '/faq',
        name: 'FAQ',
        component: FAQ,
    },
    {
        path: '/about-us',
        name: 'About',
        component: About,
    },
    {
        path: '/sign-In',
        name: 'SignIn',
        component: SignIn,
        beforeEnter: (to, from, next) => {
            if (store.state.userState === true) {
                next('/profile');
            } else {
                next();
            }
        },
    },
    {
        path: '/profile',
        name: 'Profile',
        component: Profile,
        beforeEnter: (to, from, next) => {
            if (store.state.userState === true) {
                next();
            } else {
                next('/');
            }
        },

        children: [
            {
                path: 'notification',
                name: 'Notification',
                component: Notification,
            },
        ]
    },
    {
        path: '/my-team',
        name: 'myTeamInfo',
        component: myTeamInfo,
        beforeEnter: (to, from, next) => {
            if (store.state.userState === true) {
                next();
            } else {
                next('/');
            }
        },
    },

    {
        path: '/training-support',
        name: 'Training Support',
        component: TrainingSupport,
    },
    {
        path: '/01-space',
        name: '01 Space',
        component: ZeroOneSpace,
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
